import { FC } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';

import {
  DEFAULT_LOCALE,
  GOOGLE_SITE_VER_CODE,
  MS_VER_CODE,
  PROD_URL,
} from 'src/common/constants';
import prependLocale from 'src/common/utils/prependLocale';

type CommonMetaTagsProps = {
  noindex: boolean;
  canonicalUrl?: string;
};

const CommonMetaTags: FC<CommonMetaTagsProps> = ({ noindex, canonicalUrl }) => {
  const { locale } = useRouter();
  const langCode = locale || DEFAULT_LOCALE;

  const { asPath } = useRouter();
  const [pathname] = asPath.split('?');
  const path = canonicalUrl ?? pathname;

  return (
    <Head>
      <meta
        key="meta-charset"
        charSet="utf-8"
      />
      <meta
        key="meta-viewport"
        name="viewport"
        content="initial-scale=1.0, width=device-width"
      />

      <meta
        key="meta-msvalidate"
        name="msvalidate.01"
        content={MS_VER_CODE}
      />
      <meta
        key="meta-language"
        httpEquiv="content-language"
        content={langCode}
      />
      <meta
        key="meta-msapp-tilecolor"
        name="msapplication-TileColor"
        content="#ffffff"
      />
      <meta
        key="meta-msapp-config"
        name="msapplication-config"
        content="/favicons/browserconfig.xml"
      />
      <meta
        key="meta-theme-color"
        name="theme-color"
        content="#ffffff"
      />
      <meta
        key="meta-google-site-verification"
        name="google-site-verification"
        content={GOOGLE_SITE_VER_CODE}
      />
      <link
        key="meta-apple-icon"
        rel="apple-touch-icon"
        sizes="76x76"
        href="/favicons/apple-touch-icon.png"
      />
      <link
        key="meta-icon"
        rel="icon"
        href="/favicon.ico"
      />
      <link
        key="meta-icon-32"
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicons/favicon-32x32.png"
      />
      <link
        key="meta-icon-16"
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicons/favicon-16x16.png"
      />
      <link
        key="meta-icon-mask"
        rel="mask-icon"
        href="/favicons/safari-pinned-tab.svg"
        color="#5bbad5"
      />
      <link
        key="meta-icon-manifest"
        rel="manifest"
        href="/favicons/site.webmanifest"
      />
      <link
        key="meta-icon-shortcut"
        rel="icon"
        href="/favicons/favicon.ico"
      />
      <link
        key="meta-manifest"
        rel="manifest"
        href="/static/manifest.json"
      />
      {noindex && (
        <meta
          key="meta-robots"
          name="robots"
          content="noindex"
        />
      )}
      {!noindex && (
        <link
          key="meta-canonical"
          rel="canonical"
          href={PROD_URL + prependLocale(path, locale)}
        />
      )}
    </Head>
  );
};

export default CommonMetaTags;
